// 2026 placements, exactly as announced at the award ceremony.
//
// STATIC ON PURPOSE. These could be read from judging_reports, but that table
// is behind RLS that only lets a dancer see their own published report — and
// it should stay that way, because the same rows carry the judges' written
// feedback. Opening it to anonymous reads to render a results page would
// expose every dancer's feedback along with it. The archive is history; it
// does not need to be live.
//
// The number of placements differs per division and is NOT derived from group
// size here — it is what was actually called on the night. Do not "fix" a
// division to have more or fewer entries than this.
//
// Source of truth for the underlying scores is still judging_reports. If a
// placement is ever corrected there, correct it here too.
//
// Names are first name + last initial. Most of these dancers are children, and
// a public, search-indexed results page is a different thing from a name read
// aloud in a theatre. Full names remain in the database and on each dancer's
// own report, which only they can see.

export const RESULTS_2026 = [
  {
    key: "junior-7-9",
    division: "Ages 7–9",
    category: "Competitive",
    entrants: 6,
    placements: [
      { rank: 1, dancer: "Jacqueline L.", variation: "Fairy Doll" },
      { rank: 2, dancer: "Colette H.", variation: "Divertimento" },
      { rank: 3, dancer: "Spencer C.", variation: "Siegfried Variation" },
    ],
  },
  {
    key: "junior-10-11",
    division: "Ages 10–11",
    category: "Competitive",
    entrants: 3,
    placements: [
      { rank: 1, dancer: "Sumire W.", variation: "Swanilda Act 1 Variation" },
    ],
  },
  {
    key: "junior-12-14",
    division: "Ages 12–14",
    category: "Competitive",
    entrants: 12,
    placements: [
      { rank: 1, dancer: "Luella L.", variation: "The Awakening of Flora" },
      { rank: 2, dancer: "Irene X.", variation: "Lilac Fairy Act I" },
      { rank: 3, dancer: "Izumi T.", variation: "Giselle Variation, Act I" },
      { rank: 4, dancer: "Isabella X.", variation: "Raymonda Variation" },
      { rank: 5, dancer: "Susie L.", variation: "La Fille Mal Gardée" },
    ],
  },
  {
    key: "junior-15-17",
    division: "Ages 15–17",
    category: "Competitive",
    entrants: 3,
    placements: [
      { rank: 1, dancer: "Yingfei Q.", variation: "Paquita Étoile Variation" },
    ],
  },
  {
    key: "adult-competitive",
    division: "Adult (18+)",
    category: "Competitive",
    entrants: 7,
    placements: [
      { rank: 1, dancer: "Saho U.", variation: "Aurora Variation, Act III" },
      { rank: 2, dancer: "Tiffany W.", variation: "Flower Festival" },
      { rank: 3, dancer: "Vivian L.", variation: "Henriette Variation" },
    ],
  },
  {
    key: "adult-recreational",
    division: "Adult (18+)",
    category: "Recreational",
    entrants: 28,
    placements: [
      { rank: 1, dancer: "Yolanda Q.", variation: "Swanhilda Variation" },
      { rank: 2, dancer: "Koey T.", variation: "Goddess of Dawn" },
      { rank: 3, dancer: "Angelique M.", variation: "Les Sylphides — Waltz" },
      { rank: 4, dancer: "Alexa N.", variation: "Paquita I" },
      { rank: 5, dancer: "Maria M.", variation: "Bridesmaid Variation" },
      { rank: 6, dancer: "Hang Y.", variation: "Swanhilda Variation, Act I" },
      { rank: 7, dancer: "Laurel L.", variation: "Dream Variation, Act I" },
      { rank: 8, dancer: "Xiaohan W.", variation: "Paquita Variation I" },
      { rank: 9, dancer: "JianBin C.", variation: "River Variation" },
      { rank: 10, dancer: "Ji Eun S.", variation: "Tambourine Variation" },
    ],
  },
];

// Headline facts for the season, so the archive page has no magic numbers.
export const SEASON_2026 = {
  year: 2026,
  eventDate: "September 20, 2026",
  venue: "Sandra Faire and Ivan Fecan Theatre",
  venueDetail: "York University, Toronto",
  dancers: 59,
  variations: 66,
  divisions: 6,
  judges: ["Cynthia Macedo", "Sarahí Cárdenas", "Vlad Romashchenko"],
};
